import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DevNavComponent } from './components/dev-nav/dev-nav.component';
import { environment } from '../environments/environment';
import { BlobComponent } from './components/backgrounds/blob/blob.component';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DevNavComponent, BlobComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  development: boolean = !environment.production;

  constructor(private UserService: UserService) {}

  async ngOnInit() {
    await this.UserService.checkClientRegistration();
  }
}
